import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import apiHelper from "../api/apiHelper";
import { useServices } from "../hooks/useServices";
import { useTranslation } from "react-i18next";

const Footer = () => {
  const [staticData, setStaticData] = useState(null);
  const { services, loading } = useServices();
  const { t, i18n } = useTranslation();

  useEffect(() => {
    const fetchStaticData = async () => {
      try {
        const response = await apiHelper.get("settings/contact-info/");

  const data = response.data;
  setStaticData(data);
      } catch (error) {
        // silently ignore footer errors (or handle via UI if needed)
      }
    };

    fetchStaticData();
  }, []);

  // const servicesItems = [
  //   {
  //     icon: (
  //       <svg
  //         width="24"
  //         height="24"
  //         viewBox="0 0 24 24"
  //         fill="none"
  //         xmlns="http://www.w3.org/2000/svg"
  //       >
  //         <path
  //           d="M20 19V10.5C20 10.3448 19.9639 10.1916 19.8944 10.0528C19.825 9.91393 19.7242 9.79315 19.6 9.7L12.6 4.45C12.4269 4.32018 12.2164 4.25 12 4.25C11.7836 4.25 11.5731 4.32018 11.4 4.45L4.4 9.7C4.2758 9.79315 4.175 9.91393 4.10557 10.0528C4.03614 10.1916 4 10.3448 4 10.5V19C4 19.2652 4.10536 19.5196 4.29289 19.7071C4.48043 19.8946 4.73478 20 5 20H9C9.26522 20 9.51957 19.8946 9.70711 19.7071C9.89464 19.5196 10 19.2652 10 19V16C10 15.7348 10.1054 15.4804 10.2929 15.2929C10.4804 15.1054 10.7348 15 11 15H13C13.2652 15 13.5196 15.1054 13.7071 15.2929C13.8946 15.4804 14 15.7348 14 16V19C14 19.2652 14.1054 19.5196 14.2929 19.7071C14.4804 19.8946 14.7348 20 15 20H19C19.2652 20 19.5196 19.8946 19.7071 19.7071C19.8946 19.5196 20 19.2652 20 19Z"
  //           fill="#F8F9FA"
  //           stroke="#F8F9FA"
  //           strokeWidth="2"
  //           strokeLinecap="round"
  //           strokeLinejoin="round"
  //         />
  //       </svg>
  //     ),
  //     title: "Home Cleaning",
  //     link: "#",
  //   },
  //   {
  //     icon: (
  //       <svg
  //         width="24"
  //         height="24"
  //         viewBox="0 0 24 24"
  //         fill="none"
  //         xmlns="http://www.w3.org/2000/svg"
  //       >
  //         <path
  //           d="M9.10698 5.448C9.70498 3.698 12.123 3.645 12.832 5.289L12.892 5.449L13.699 7.809C13.8839 8.35023 14.1828 8.84551 14.5754 9.26142C14.968 9.67734 15.4453 10.0042 15.975 10.22L16.192 10.301L18.552 11.107C20.302 11.705 20.355 14.123 18.712 14.832L18.552 14.892L16.192 15.699C15.6506 15.8838 15.1551 16.1826 14.739 16.5753C14.3229 16.9679 13.9959 17.4452 13.78 17.975L13.699 18.191L12.893 20.552C12.295 22.302 9.87698 22.355 9.16898 20.712L9.10698 20.552L8.30098 18.192C8.11616 17.6506 7.81735 17.1551 7.42472 16.739C7.03209 16.3229 6.55478 15.9959 6.02498 15.78L5.80898 15.699L3.44898 14.893C1.69798 14.295 1.64498 11.877 3.28898 11.169L3.44898 11.107L5.80898 10.301C6.35022 10.1161 6.84549 9.81719 7.26141 9.42457C7.67732 9.03195 8.00419 8.55469 8.21998 8.025L8.30098 7.809L9.10698 5.448ZM11 6.094L10.194 8.454C9.91237 9.2793 9.45425 10.0333 8.85152 10.6635C8.24879 11.2937 7.51593 11.7849 6.70398 12.103L6.45398 12.194L4.09398 13L6.45398 13.806C7.27929 14.0876 8.03329 14.5457 8.66348 15.1485C9.29367 15.7512 9.78491 16.4841 10.103 17.296L10.194 17.546L11 19.906L11.806 17.546C12.0876 16.7207 12.5457 15.9667 13.1484 15.3365C13.7512 14.7063 14.484 14.2151 15.296 13.897L15.546 13.807L17.906 13L15.546 12.194C14.7207 11.9124 13.9667 11.4543 13.3365 10.8515C12.7063 10.2488 12.2151 9.51595 11.897 8.704L11.807 8.454L11 6.094ZM19 2C19.1871 2 19.3704 2.05248 19.5291 2.15147C19.6879 2.25046 19.8157 2.392 19.898 2.56L19.946 2.677L20.296 3.703L21.323 4.053C21.5105 4.1167 21.6748 4.23462 21.7952 4.39182C21.9156 4.54902 21.9866 4.73842 21.9993 4.93602C22.0119 5.13362 21.9656 5.33053 21.8662 5.50179C21.7668 5.67304 21.6188 5.81094 21.441 5.898L21.323 5.946L20.297 6.296L19.947 7.323C19.8832 7.51043 19.7652 7.6747 19.6079 7.79499C19.4506 7.91529 19.2612 7.98619 19.0636 7.99872C18.866 8.01125 18.6692 7.96484 18.498 7.86538C18.3268 7.76591 18.189 7.61787 18.102 7.44L18.054 7.323L17.704 6.297L16.677 5.947C16.4895 5.8833 16.3251 5.76538 16.2048 5.60819C16.0844 5.45099 16.0133 5.26158 16.0007 5.06398C15.9881 4.86638 16.0344 4.66947 16.1338 4.49821C16.2332 4.32696 16.3811 4.18906 16.559 4.102L16.677 4.054L17.703 3.704L18.053 2.677C18.1204 2.47943 18.248 2.30791 18.4178 2.1865C18.5876 2.06509 18.7912 1.99987 19 2Z"
  //           fill="#F8F9FA"
  //         />
  //       </svg>
  //     ),
  //     title: "Deep Cleaning",
  //     link: "#",
  //   },

  //   {
  //     icon: (
  //       <svg
  //         width="24"
  //         height="24"
  //         viewBox="0 0 24 24"
  //         fill="none"
  //         xmlns="http://www.w3.org/2000/svg"
  //       >
  //         <path
  //           d="M18.8079 12.8383C16.8119 11.8968 16.9231 11.9333 16.8 11.9333H15.3106V10.078L16.9706 9.29493C17.0521 9.25653 17.1194 9.19166 17.1627 9.10998L18.0813 7.37666C18.1923 7.1673 18.1199 6.90361 17.9195 6.78759C17.7192 6.67169 17.4669 6.74744 17.3559 6.95674L16.504 8.56424L15.3106 9.12711V8.89996C15.3106 8.66073 15.125 8.46663 14.896 8.46663H14.4761C14.4761 7.68539 14.1428 6.98349 13.6163 6.50648L14.3538 5.74073C14.5162 5.57202 14.517 5.29769 14.3556 5.12797C14.1942 4.95825 13.9316 4.95732 13.7692 5.12603L12.8846 6.04472C12.302 5.80754 11.6492 5.80708 11.0656 6.04472L10.181 5.12595C10.0185 4.95724 9.75603 4.95816 9.59461 5.12788C9.43318 5.29772 9.43393 5.57204 9.59643 5.74075L10.3338 6.50651C9.80731 6.98349 9.47412 7.68539 9.47412 8.46663H9.05419C8.82519 8.46663 8.63958 8.66062 8.63958 8.89996V9.12711L7.44625 8.56427L6.59423 6.95674C6.48323 6.74729 6.23103 6.67169 6.03063 6.78759C5.83023 6.90361 5.75787 7.1673 5.86876 7.37663L6.78739 9.10995C6.83067 9.19165 6.89805 9.25653 6.9795 9.29493L8.63947 10.078V11.9333C7.00907 11.9333 7.09026 11.9195 6.9795 11.9716L5.14232 12.8383C4.73622 13.0299 4.86914 13.6667 5.31315 13.6667C5.43579 13.6667 5.33838 13.6967 7.23938 12.7999H8.63947C8.63947 13.7017 8.61033 14.0561 8.7712 14.6318L6.98608 15.4352C6.90176 15.4732 6.83189 15.5394 6.78739 15.6233L5.86876 17.3567C5.71499 17.6467 5.91821 18 6.23114 18C6.377 18 6.51855 17.9193 6.59423 17.7766L7.44431 16.1727L9.10224 15.4263C10.3961 17.699 13.5527 17.7015 14.8479 15.4263L16.5059 16.1727L17.3559 17.7766C17.4315 17.9194 17.5731 18 17.719 18C18.032 18 18.2351 17.6467 18.0814 17.3567L17.1627 15.6233C17.1182 15.5394 17.0483 15.4732 16.964 15.4352L15.179 14.6318C15.34 14.0551 15.3106 13.7001 15.3106 12.7999H16.7107C18.6141 13.6978 18.5146 13.6667 18.637 13.6667C19.0816 13.6667 19.2136 13.0297 18.8079 12.8383ZM11.9751 6.73331C12.8969 6.73331 13.6468 7.51094 13.6468 8.46663H10.3034C10.3034 7.51094 11.0532 6.73331 11.9751 6.73331ZM9.46881 13.6666V9.33329H11.5604V16.2308C10.3751 16.0252 9.46881 14.9537 9.46881 13.6666ZM12.3897 16.2308V9.33329H14.4814V13.6666C14.4814 14.9537 13.575 16.0252 12.3897 16.2308Z"
  //           fill="#F8F9FA"
  //         />
  //       </svg>
  //     ),
  //     title: "Pest Control",
  //     link: "#",
  //   },

  //   {
  //     icon: (
  //       <svg
  //         width="24"
  //         height="24"
  //         viewBox="0 0 24 24"
  //         fill="none"
  //         xmlns="http://www.w3.org/2000/svg"
  //       >
  //         <g clipPath="url(#clip0_493_101)">
  //           <path
  //             d="M21.6 17.6H18.72L13.12 0.799961C12.8 -0.320039 11.2 -0.320039 10.88 0.799961L5.27998 17.6H2.39998C1.91998 17.6 1.59998 17.92 1.59998 18.4V20C1.59998 20.48 1.91998 20.8 2.39998 20.8H21.6C22.08 20.8 22.4 20.48 22.4 20V18.4C22.4 17.92 22.08 17.6 21.6 17.6ZM11.2 4.79996H12.8L13.92 7.99996H10.24L11.2 4.79996ZM9.11997 11.2H14.88L16 14.4H7.99998L9.11997 11.2Z"
  //             fill="#F8F9FA"
  //           />
  //         </g>
  //         <defs>
  //           <clipPath id="clip0_493_101">
  //             <rect width="24" height="24" fill="white" />
  //           </clipPath>
  //         </defs>
  //       </svg>
  //     ),
  //     title: "Post-Construction",
  //     link: "#",
  //   },

  //   {
  //     icon: (
  //       <svg
  //         width="24"
  //         height="24"
  //         viewBox="0 0 24 24"
  //         fill="none"
  //         xmlns="http://www.w3.org/2000/svg"
  //       >
  //         <path
  //           d="M13.4 19V9.2M13.4 19H9.2C7.2204 19 6.2299 19 5.6153 18.3847C5 17.7701 5 16.7796 5 14.8V9.2C5 7.2204 5 6.2299 5.6153 5.6153C6.2299 5 7.2204 5 9.2 5C11.1796 5 12.1701 5 12.7847 5.6153C13.4 6.2299 13.4 7.2204 13.4 9.2M13.4 19H16.2C17.5202 19 18.1796 19 18.5898 18.5898C19 18.1796 19 17.5202 19 16.2V12C19 10.6798 19 10.0204 18.5898 9.6102C18.1796 9.2 17.5202 9.2 16.2 9.2H13.4M8.15 11.3H7.45M10.95 11.3H10.25M8.15 8.5H7.45M8.15 14.1H7.45M10.95 8.5H10.25M10.95 14.1H10.25M16.55 14.1H15.85M16.55 11.3H15.85"
  //           stroke="#F8F9FA"
  //           strokeLinecap="round"
  //         />
  //       </svg>
  //     ),
  //     title: "Office & Commercial",
  //     link: "#",
  //   },
  // ];
  
  const quickLinksItems = [
    {
      icon: (
        <svg
          width="24"
          height="25"
          viewBox="0 0 24 25"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M12 3C13.3168 3 14.5493 3.24984 15.7021 3.74707C16.8645 4.24844 17.8697 4.92571 18.7217 5.77832C19.5739 6.63117 20.2512 7.63681 20.7539 8.79883C21.2521 9.95047 21.5019 11.1821 21.5 12.499C21.4981 13.8169 21.2483 15.0498 20.7529 16.2021C20.2537 17.3634 19.5761 18.3681 18.7217 19.2207C17.8666 20.0739 16.8612 20.7518 15.7012 21.2539C14.5516 21.7514 13.3193 22.0013 12 22C10.6818 22 9.44919 21.7501 8.29785 21.2529C7.13685 20.7516 6.13174 20.0744 5.27832 19.2217C4.42499 18.369 3.74774 17.3638 3.24707 16.2021C2.7505 15.05 2.50067 13.8176 2.5 12.5C2.49936 11.1827 2.74931 9.94982 3.24707 8.79785C3.74911 7.6361 4.42629 6.63101 5.27832 5.77832C6.1303 4.92571 7.13546 4.24844 8.29785 3.74707C9.4507 3.24984 10.6832 3 12 3ZM12 4C9.63686 4 7.61741 4.82595 5.97168 6.47168C4.32595 8.11741 3.5 10.1369 3.5 12.5C3.5 14.8631 4.32595 16.8826 5.97168 18.5283C7.61741 20.1741 9.63686 21 12 21C14.3631 21 16.3826 20.1741 18.0283 18.5283C19.6741 16.8826 20.5 14.8631 20.5 12.5C20.5 10.1369 19.6741 8.11741 18.0283 6.47168C16.3826 4.82595 14.3631 4 12 4ZM12.5 12V17H11.5V12H12.5ZM12 8C12.1569 8 12.2646 8.04766 12.3574 8.14062C12.4513 8.23479 12.4996 8.34403 12.5 8.50098C12.5004 8.65672 12.4531 8.76468 12.3594 8.8584C12.2891 8.92871 12.2105 8.97337 12.1094 8.99121L12 9H11.998C11.8443 9.00073 11.7363 8.95406 11.6416 8.85938C11.5469 8.76463 11.4996 8.65618 11.5 8.50098C11.5004 8.34403 11.5487 8.23479 11.6426 8.14062C11.7354 8.04766 11.8431 8 12 8Z"
            fill="#F8F9FA"
            stroke="#F8F9FA"
          />
        </svg>
      ),
      titleKey: "footer.quick.about_us",
      link: "#",
    },

    {
      icon: (
        <svg
          width="24"
          height="25"
          viewBox="0 0 24 25"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M10.944 1.75H13.056C14.894 1.75 16.35 1.75 17.489 1.903C18.661 2.061 19.61 2.393 20.359 3.141C21.107 3.89 21.439 4.839 21.597 6.011C21.75 7.151 21.75 8.606 21.75 10.444V14.556C21.75 16.394 21.75 17.85 21.597 18.989C21.439 20.161 21.107 21.11 20.359 21.859C19.61 22.607 18.661 22.939 17.489 23.097C16.349 23.25 14.894 23.25 13.056 23.25H10.944C9.106 23.25 7.65 23.25 6.511 23.097C5.339 22.939 4.39 22.607 3.641 21.859C2.893 21.11 2.561 20.161 2.403 18.989C2.25 17.849 2.25 16.394 2.25 14.556V10.444C2.25 8.606 2.25 7.15 2.403 6.011C2.561 4.839 2.893 3.89 3.641 3.141C4.39 2.393 5.339 2.061 6.511 1.903C7.651 1.75 9.106 1.75 10.944 1.75ZM6.71 3.39C5.704 3.525 5.124 3.779 4.7 4.202C4.278 4.625 4.024 5.205 3.889 6.211C3.751 7.239 3.749 8.593 3.749 10.5V14.5C3.749 16.407 3.751 17.762 3.889 18.79C4.024 19.795 4.278 20.375 4.701 20.798C5.124 21.221 5.704 21.475 6.71 21.61C7.738 21.748 9.092 21.75 10.999 21.75H12.999C14.906 21.75 16.261 21.748 17.289 21.61C18.294 21.475 18.874 21.221 19.297 20.798C19.72 20.375 19.974 19.795 20.109 18.789C20.247 17.762 20.249 16.407 20.249 14.5V10.5C20.249 8.593 20.247 7.239 20.109 6.21C19.974 5.205 19.72 4.625 19.297 4.202C18.874 3.779 18.294 3.525 17.288 3.39C16.261 3.252 14.906 3.25 12.999 3.25H10.999C9.092 3.25 7.739 3.252 6.71 3.39ZM7.25 10.5C7.25 10.3011 7.32902 10.1103 7.46967 9.96967C7.61032 9.82902 7.80109 9.75 8 9.75H16C16.1989 9.75 16.3897 9.82902 16.5303 9.96967C16.671 10.1103 16.75 10.3011 16.75 10.5C16.75 10.6989 16.671 10.8897 16.5303 11.0303C16.3897 11.171 16.1989 11.25 16 11.25H8C7.80109 11.25 7.61032 11.171 7.46967 11.0303C7.32902 10.8897 7.25 10.6989 7.25 10.5ZM7.25 14.5C7.25 14.3011 7.32902 14.1103 7.46967 13.9697C7.61032 13.829 7.80109 13.75 8 13.75H13C13.1989 13.75 13.3897 13.829 13.5303 13.9697C13.671 14.1103 13.75 14.3011 13.75 14.5C13.75 14.6989 13.671 14.8897 13.5303 15.0303C13.3897 15.171 13.1989 15.25 13 15.25H8C7.80109 15.25 7.61032 15.171 7.46967 15.0303C7.32902 14.8897 7.25 14.6989 7.25 14.5Z"
            fill="#F8F9FA"
          />
        </svg>
      ),
      titleKey: "footer.quick.get_quote",
      link: "#",
    },

    {
      icon: (
        <svg
          width="24"
          height="25"
          viewBox="0 0 24 25"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clipPath="url(#clip0_493_126)">
            <path
              d="M22.0573 6.67957C22.045 6.03161 22.0332 5.41948 22.0332 4.82729C22.0332 4.6045 21.9447 4.39082 21.7872 4.23328C21.6296 4.07574 21.416 3.98723 21.1932 3.98723C17.6005 3.98723 14.8652 2.95474 12.5851 0.737875C12.4283 0.585343 12.2182 0.5 11.9995 0.5C11.7807 0.5 11.5706 0.585343 11.4139 0.737875C9.13404 2.95474 6.39913 3.98723 2.80669 3.98723C2.5839 3.98723 2.37022 4.07574 2.21268 4.23328C2.05514 4.39082 1.96663 4.6045 1.96663 4.82729C1.96663 5.41959 1.95498 6.03194 1.94255 6.68002C1.82741 12.7101 1.6697 20.9686 11.7243 24.4537C11.9025 24.5155 12.0963 24.5155 12.2745 24.4537C22.3299 20.9685 22.1725 12.7098 22.0573 6.67957ZM11.9995 22.7685C3.37637 19.636 3.50674 12.7738 3.62245 6.71206C3.62939 6.34825 3.63611 5.99565 3.64082 5.65C7.00555 5.50797 9.69621 4.48836 11.9995 2.48184C14.3031 4.48836 16.9942 5.50808 20.3592 5.65C20.3639 5.99554 20.3706 6.34792 20.3775 6.7115C20.4931 12.7735 20.6234 19.6359 11.9995 22.7685Z"
              fill="#F8F9FA"
            />
            <path
              d="M14.8924 9.58177L10.8378 13.6361L9.10761 11.9059C8.94917 11.7528 8.73689 11.668 8.51653 11.6699C8.29617 11.6718 8.08537 11.7601 7.92956 11.916C7.77374 12.0718 7.68538 12.2826 7.68353 12.503C7.68168 12.7233 7.76648 12.9356 7.91965 13.094L10.2438 15.4182C10.3217 15.4963 10.4143 15.5582 10.5163 15.6004C10.6182 15.6426 10.7275 15.6643 10.8378 15.6642C10.9481 15.6643 11.0574 15.6426 11.1593 15.6004C11.2613 15.5582 11.3539 15.4963 11.4318 15.4182L16.0802 10.7698C16.1583 10.6919 16.2202 10.5993 16.2624 10.4974C16.3046 10.3954 16.3264 10.2862 16.3264 10.1759C16.3264 10.0656 16.3047 9.95633 16.2625 9.85441C16.2202 9.75249 16.1584 9.65988 16.0803 9.58189C15.9228 9.42435 15.7092 9.33584 15.4864 9.33582C15.2636 9.33579 15.0499 9.42427 14.8924 9.58177Z"
              fill="#F8F9FA"
            />
          </g>
          <defs>
            <clipPath id="clip0_493_126">
              <rect
                width="24"
                height="24"
                fill="white"
                transform="translate(0 0.5)"
              />
            </clipPath>
          </defs>
        </svg>
      ),
      titleKey: "footer.quick.privacy_policy",
      link: "#",
    },

    {
      icon: (
        <svg
          width="24"
          height="25"
          viewBox="0 0 24 25"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M10.944 1.75H13.056C14.894 1.75 16.35 1.75 17.489 1.903C18.661 2.061 19.61 2.393 20.359 3.141C21.107 3.89 21.439 4.839 21.597 6.011C21.75 7.151 21.75 8.606 21.75 10.444V14.556C21.75 16.394 21.75 17.85 21.597 18.989C21.439 20.161 21.107 21.11 20.359 21.859C19.61 22.607 18.661 22.939 17.489 23.097C16.349 23.25 14.894 23.25 13.056 23.25H10.944C9.106 23.25 7.65 23.25 6.511 23.097C5.339 22.939 4.39 22.607 3.641 21.859C2.893 21.11 2.561 20.161 2.403 18.989C2.25 17.849 2.25 16.394 2.25 14.556V10.444C2.25 8.606 2.25 7.15 2.403 6.011C2.561 4.839 2.893 3.89 3.641 3.141C4.39 2.393 5.339 2.061 6.511 1.903C7.651 1.75 9.106 1.75 10.944 1.75ZM6.71 3.39C5.704 3.525 5.124 3.779 4.7 4.202C4.278 4.625 4.024 5.205 3.889 6.211C3.751 7.239 3.749 8.593 3.749 10.5V14.5C3.749 16.407 3.751 17.762 3.889 18.79C4.024 19.795 4.278 20.375 4.701 20.798C5.124 21.221 5.704 21.475 6.71 21.61C7.738 21.748 9.092 21.75 10.999 21.75H12.999C14.906 21.75 16.261 21.748 17.289 21.61C18.294 21.475 18.874 21.221 19.297 20.798C19.72 20.375 19.974 19.795 20.109 18.789C20.247 17.762 20.249 16.407 20.249 14.5V10.5C20.249 8.593 20.247 7.239 20.109 6.21C19.974 5.205 19.72 4.625 19.297 4.202C18.874 3.779 18.294 3.525 17.288 3.39C16.261 3.252 14.906 3.25 12.999 3.25H10.999C9.092 3.25 7.739 3.252 6.71 3.39ZM7.25 10.5C7.25 10.3011 7.32902 10.1103 7.46967 9.96967C7.61032 9.82902 7.80109 9.75 8 9.75H16C16.1989 9.75 16.3897 9.82902 16.5303 9.96967C16.671 10.1103 16.75 10.3011 16.75 10.5C16.75 10.6989 16.671 10.8897 16.5303 11.0303C16.3897 11.171 16.1989 11.25 16 11.25H8C7.80109 11.25 7.61032 11.171 7.46967 11.0303C7.32902 10.8897 7.25 10.6989 7.25 10.5ZM7.25 14.5C7.25 14.3011 7.32902 14.1103 7.46967 13.9697C7.61032 13.829 7.80109 13.75 8 13.75H13C13.1989 13.75 13.3897 13.829 13.5303 13.9697C13.671 14.1103 13.75 14.3011 13.75 14.5C13.75 14.6989 13.671 14.8897 13.5303 15.0303C13.3897 15.171 13.1989 15.25 13 15.25H8C7.80109 15.25 7.61032 15.171 7.46967 15.0303C7.32902 14.8897 7.25 14.6989 7.25 14.5Z"
            fill="#F8F9FA"
          />
        </svg>
      ),
      titleKey: "footer.quick.terms_of_service",
      link: "#",
    },
    {
      icon: (
        <svg
          width="24"
          height="25"
          viewBox="0 0 24 25"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M12 8.5C12 8.5 12 8.5 11.24 7.5C10.36 6.34 9.06 5.5 7.5 5.5C5.01 5.5 3 7.51 3 10C3 10.93 3.28 11.79 3.76 12.5C4.57 13.71 12 21.5 12 21.5M12 8.5C12 8.5 12 8.5 12.76 7.5C13.64 6.34 14.94 5.5 16.5 5.5C18.99 5.5 21 7.51 21 10C21 10.93 20.72 11.79 20.24 12.5C19.43 13.71 12 21.5 12 21.5"
            stroke="#F8F9FA"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      ),
      titleKey: "footer.quick.careers",
      link: "#",
    },
  ];

  const socialMediaItems = [
    {
      name: "Facebook",
      iconClass: "icon-[tabler--brand-facebook]",
      link: staticData?.facebook_url || "https://www.facebook.com/",
    },

    {
      name: "Instagram",
      iconClass: "icon-[tabler--brand-instagram]",
      link: staticData?.instagram_url || "https://www.instagram.com/",
    },

    {
      name: "LinkedIn",
      iconClass: "icon-[tabler--brand-linkedin]",
      link: staticData?.linkedin_url || "https://www.linkedin.com/",
    },
    {
      name: "X",
      iconClass: "icon-[tabler--brand-x]",
      link: staticData?.twitter_url || "https://www.x.com/",
    },
    {
      name: "YouTube",
      iconClass: "icon-[tabler--brand-youtube]",
      link: staticData?.youtube_url || "https://www.youtube.com/",
    },
  ];
  return (
    <>
      <div className="w-full footer_bg_gradient">
        <footer className="footer py-14 px-8 ">
          <div className=" grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 xl:grid-cols-4">
            <div className="gap-0">
              <div className="flex items-center gap-2 text-2xl font-semibold text-primary-light mb-4">
                <img src="./assets/imgs/global/logo_footer.svg" alt="" />
                <span> {staticData?.company_name || t("company_name") } </span>
              </div>
              <p className="text-sm font-normal text-primary-light mb-8 max-w-sm">
                {staticData?.[`tagline_${i18n.language}`] || t("footer_tagline") || staticData?.tagline}
              </p>

              <div className="bg-[#229E5B] rounded-lg flex items-center gap-3 p-2 pe-4 mb-4">
                <div className="size-8 rounded-lg bg-[#00C950] center_flex ">
                  <span className="icon-[mingcute--phone-fill] text-white"></span>{" "}
                </div>
                <div>
                  <a href={`tel:${staticData?.phone_number || "+971 55 444 5555"}`}>
                    <p className="text-base font-semibold text-primary-light ">
                      {t("call_now")}
                    </p>
                    <p className="text-base font-semibold text-primary-light">
                      {staticData?.phone_number || "+971 55 444 5555"}
                    </p>
                  </a>
                </div>
              </div>

              <div className="bg-[#229E5B] rounded-lg flex items-center gap-3 p-2 pe-5 mb-4">
                <div className="size-8 rounded-lg bg-[#00C950] center_flex ">
                  <span className="icon-[basil--whatsapp-solid] text-white"></span>{" "}
                </div>
                <div>
                  <a
                    href="https://wa.me/200000000000"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <p className="text-base font-semibold text-primary-light ">
                      {t("whatsapp_us")}
                    </p>
                    <p className="text-base font-semibold text-primary-light">
                      {t("instant_response")}
                    </p>
                  </a>
                </div>
              </div>
            </div>

            <nav className="text-base-content text-white gap-0">
              <h6 className="footer-title flex items-center gap-2 text-white font-semibold text-xl mb-8">
                <svg
                  width="32"
                  height="32"
                  viewBox="0 0 32 32"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M12.1428 7.26384C12.9401 4.9305 16.1641 4.85984 17.1095 7.05184L17.1895 7.26517L18.2655 10.4118C18.5121 11.1335 18.9105 11.7939 19.434 12.3484C19.9575 12.903 20.5939 13.3388 21.3001 13.6265L21.5895 13.7345L24.7361 14.8092C27.0695 15.6065 27.1401 18.8305 24.9495 19.7758L24.7361 19.8558L21.5895 20.9318C20.8676 21.1783 20.207 21.5767 19.6522 22.1002C19.0974 22.6237 18.6613 23.2601 18.3735 23.9665L18.2655 24.2545L17.1908 27.4025C16.3935 29.7358 13.1695 29.8065 12.2255 27.6158L12.1428 27.4025L11.0681 24.2558C10.8217 23.5339 10.4233 22.8733 9.89979 22.3185C9.37629 21.7637 8.73986 21.3277 8.03347 21.0398L7.74547 20.9318L4.59881 19.8572C2.26414 19.0598 2.19347 15.8358 4.38547 14.8918L4.59881 14.8092L7.74547 13.7345C8.46712 13.4879 9.12749 13.0894 9.68204 12.5659C10.2366 12.0424 10.6724 11.4061 10.9601 10.6998L11.0681 10.4118L12.1428 7.26384ZM14.6668 8.12517L13.5921 11.2718C13.2167 12.3722 12.6058 13.3776 11.8022 14.2178C10.9985 15.0581 10.0214 15.7131 8.93881 16.1372L8.60547 16.2585L5.45881 17.3332L8.60547 18.4078C9.70588 18.7833 10.7112 19.3941 11.5515 20.1978C12.3917 21.0014 13.0467 21.9786 13.4708 23.0612L13.5921 23.3945L14.6668 26.5412L15.7415 23.3945C16.117 22.2941 16.7278 21.2888 17.5314 20.4485C18.3351 19.6083 19.3122 18.9533 20.3948 18.5292L20.7281 18.4092L23.8748 17.3332L20.7281 16.2585C19.6277 15.883 18.6224 15.2722 17.7821 14.4686C16.9419 13.6649 16.2869 12.6878 15.8628 11.6052L15.7428 11.2718L14.6668 8.12517ZM25.3335 2.6665C25.5829 2.6665 25.8274 2.73647 26.039 2.86847C26.2507 3.00046 26.4211 3.18917 26.5308 3.41317L26.5948 3.56917L27.0615 4.93717L28.4308 5.40384C28.6808 5.48877 28.8999 5.64599 29.0604 5.85559C29.221 6.06519 29.3157 6.31773 29.3325 6.5812C29.3494 6.84467 29.2876 7.10721 29.1551 7.33555C29.0226 7.5639 28.8253 7.74776 28.5881 7.86384L28.4308 7.92784L27.0628 8.3945L26.5961 9.76384C26.5111 10.0137 26.3537 10.2328 26.144 10.3932C25.9344 10.5536 25.6818 10.6481 25.4183 10.6648C25.1549 10.6815 24.8924 10.6196 24.6641 10.487C24.4359 10.3544 24.2521 10.157 24.1361 9.91984L24.0721 9.76384L23.6055 8.39584L22.2361 7.92917C21.9862 7.84424 21.767 7.68702 21.6065 7.47742C21.446 7.26782 21.3513 7.01528 21.3344 6.75181C21.3176 6.48834 21.3793 6.2258 21.5118 5.99745C21.6444 5.76911 21.8417 5.58525 22.0788 5.46917L22.2361 5.40517L23.6041 4.9385L24.0708 3.56917C24.1607 3.30574 24.3308 3.07705 24.5573 2.91517C24.7837 2.75329 25.0551 2.66634 25.3335 2.6665Z"
                    fill="#F8F9FA"
                  />
                </svg>
                {t("our_services")}
              </h6>
              {Array.isArray(services) &&
                services.map((item) => (
                  <Link
                    to={`/services/${item.service_type}`} // e.g. /services/home_cleaning
                    key={item.id}
                    className="link no-underline text-base font-normal text-white flex items-center gap-2 mb-4 hover:text-white/80"
                  >
                    <span className={`${item.icon} text-white size-6`}></span>{" "}
                    {item.name}
                  </Link>
                ))}
            </nav>

            <nav className="text-base-content text-white gap-0">
              <h6 className="footer-title flex items-center gap-2 text-white font-semibold text-xl mb-8">
                <svg
                  width="32"
                  height="33"
                  viewBox="0 0 32 33"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M14.592 2.16663H17.408C19.8587 2.16663 21.8 2.16663 23.3187 2.37063C24.8813 2.58129 26.1467 3.02396 27.1453 4.02129C28.1427 5.01996 28.5853 6.28529 28.796 7.84796C29 9.36796 29 11.308 29 13.7586V19.2413C29 21.692 29 23.6333 28.796 25.152C28.5853 26.7146 28.1427 27.98 27.1453 28.9786C26.1467 29.976 24.8813 30.4186 23.3187 30.6293C21.7987 30.8333 19.8587 30.8333 17.408 30.8333H14.592C12.1413 30.8333 10.2 30.8333 8.68133 30.6293C7.11867 30.4186 5.85333 29.976 4.85467 28.9786C3.85733 27.98 3.41467 26.7146 3.204 25.152C3 23.632 3 21.692 3 19.2413V13.7586C3 11.308 3 9.36663 3.204 7.84796C3.41467 6.28529 3.85733 5.01996 4.85467 4.02129C5.85333 3.02396 7.11867 2.58129 8.68133 2.37063C10.2013 2.16663 12.1413 2.16663 14.592 2.16663ZM8.94667 4.35329C7.60533 4.53329 6.832 4.87196 6.26667 5.43596C5.704 5.99996 5.36533 6.77329 5.18533 8.11463C5.00133 9.48529 4.99867 11.2906 4.99867 13.8333V19.1666C4.99867 21.7093 5.00133 23.516 5.18533 24.8866C5.36533 26.2266 5.704 27 6.268 27.564C6.832 28.128 7.60533 28.4666 8.94667 28.6466C10.3173 28.8306 12.1227 28.8333 14.6653 28.8333H17.332C19.8747 28.8333 21.6813 28.8306 23.052 28.6466C24.392 28.4666 25.1653 28.128 25.7293 27.564C26.2933 27 26.632 26.2266 26.812 24.8853C26.996 23.516 26.9987 21.7093 26.9987 19.1666V13.8333C26.9987 11.2906 26.996 9.48529 26.812 8.11329C26.632 6.77329 26.2933 5.99996 25.7293 5.43596C25.1653 4.87196 24.392 4.53329 23.0507 4.35329C21.6813 4.16929 19.8747 4.16663 17.332 4.16663H14.6653C12.1227 4.16663 10.3187 4.16929 8.94667 4.35329ZM9.66667 13.8333C9.66667 13.5681 9.77202 13.3137 9.95956 13.1262C10.1471 12.9387 10.4015 12.8333 10.6667 12.8333H21.3333C21.5986 12.8333 21.8529 12.9387 22.0404 13.1262C22.228 13.3137 22.3333 13.5681 22.3333 13.8333C22.3333 14.0985 22.228 14.3529 22.0404 14.5404C21.8529 14.7279 21.5986 14.8333 21.3333 14.8333H10.6667C10.4015 14.8333 10.1471 14.7279 9.95956 14.5404C9.77202 14.3529 9.66667 14.0985 9.66667 13.8333ZM9.66667 19.1666C9.66667 18.9014 9.77202 18.6471 9.95956 18.4595C10.1471 18.272 10.4015 18.1666 10.6667 18.1666H17.3333C17.5985 18.1666 17.8529 18.272 18.0404 18.4595C18.228 18.6471 18.3333 18.9014 18.3333 19.1666C18.3333 19.4318 18.228 19.6862 18.0404 19.8737C17.8529 20.0613 17.5985 20.1666 17.3333 20.1666H10.6667C10.4015 20.1666 10.1471 20.0613 9.95956 19.8737C9.77202 19.6862 9.66667 19.4318 9.66667 19.1666Z"
                    fill="#F8F9FA"
                  />
                </svg>
                {t("footer.quick_links")}
              </h6>
              <div className="mb-7">
                {Array.isArray(quickLinksItems) &&
                  quickLinksItems.map((item, index) => (
                    <Link
                      key={index}
                      to="#"
                      className="link no-underline text-base font-normal text-white flex items-center gap-2 mb-4 hover:text-white/80"
                    >
                      <span>
                        {
                          item.icon /* Use dangerouslySetInnerHTML to render the SVG string as HTML */
                        }
                      </span>{" "}
                      {t(item.titleKey)}
                    </Link>
                  ))}
              </div>

              <div className="bg-[#4E7770] rounded-[10px] px-4 py-2">
                <h4 className="footer-title flex items-center gap-2 text-muted-light font-semibold text-xl mb-4">
                  <span>
                    <svg
                      width="32"
                      height="32"
                      viewBox="0 0 32 32"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g clipPath="url(#clip0_493_141)">
                        <path
                          d="M21.701 18.8257L17.2393 15.4795V8.66308C17.2393 7.97771 16.6853 7.42371 15.9999 7.42371C15.3146 7.42371 14.7606 7.97771 14.7606 8.66308V16.0992C14.7606 16.4896 14.944 16.8577 15.2563 17.0907L20.2137 20.8088C20.4276 20.9699 20.6882 21.0569 20.9561 21.0566C21.3341 21.0566 21.7059 20.8868 21.9488 20.5596C22.3604 20.013 22.2488 19.236 21.701 18.8257Z"
                          fill="#F8F9FA"
                        />
                        <path
                          d="M16 0C7.17706 0 0 7.17706 0 16C0 24.8229 7.17706 32 16 32C24.8229 32 32 24.8229 32 16C32 7.17706 24.8229 0 16 0ZM16 29.5213C8.54531 29.5213 2.47869 23.4547 2.47869 16C2.47869 8.54531 8.54531 2.47869 16 2.47869C23.4559 2.47869 29.5213 8.54531 29.5213 16C29.5213 23.4547 23.4547 29.5213 16 29.5213Z"
                          fill="#F8F9FA"
                        />
                      </g>
                      <defs>
                        <clipPath id="clip0_493_141">
                          <rect width="32" height="32" fill="white" />
                        </clipPath>
                      </defs>
                    </svg>
                  </span>
                  {t("working_hours")}
                </h4>
                <p className="text-lg font-normal text-muted-light mb-4">
                  Monday - Friday: {staticData?.mon_fri_hours || "8:00 AM - 8:00 PM"}
                  <br />
                  Saturday: {staticData?.saturday_hours || "9:00 AM - 6:00 PM"}
                  <br />
                  Sunday: {staticData?.sunday_hours || "10:00 AM - 5:00 PM"}
                </p>
                <p className="text-base font-semibold text-success ">
                  {staticData?.emergency_available
                    ? t("emergency_247")
                    : t("no_emergency_services")}
                </p>
              </div>
            </nav>
            <nav className="text-base-content text-white gap-0">
              <h6 className="footer-title flex items-center gap-2 text-white font-semibold text-xl mb-3.5">
                <svg
                  width="32"
                  height="32"
                  viewBox="0 0 32 32"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M13.4867 29.0814C14.2947 29.748 15.1373 30.3574 16 30.952C16.8645 30.3653 17.7031 29.7411 18.5133 29.0814C19.864 27.9723 21.1351 26.7698 22.3173 25.4827C25.0427 22.5027 28 18.1827 28 13.3334C28 11.7575 27.6896 10.1971 27.0866 8.74117C26.4835 7.28527 25.5996 5.9624 24.4853 4.84809C23.371 3.73379 22.0481 2.84988 20.5922 2.24682C19.1363 1.64376 17.5759 1.33337 16 1.33337C14.4241 1.33337 12.8637 1.64376 11.4078 2.24682C9.95189 2.84988 8.62902 3.73379 7.51472 4.84809C6.40042 5.9624 5.5165 7.28527 4.91345 8.74117C4.31039 10.1971 4 11.7575 4 13.3334C4 18.1827 6.95733 22.5014 9.68267 25.4827C10.8648 26.7703 12.136 27.9719 13.4867 29.0814ZM16 17.6667C14.8507 17.6667 13.7485 17.2102 12.9359 16.3975C12.1232 15.5848 11.6667 14.4826 11.6667 13.3334C11.6667 12.1841 12.1232 11.0819 12.9359 10.2692C13.7485 9.45659 14.8507 9.00004 16 9.00004C17.1493 9.00004 18.2515 9.45659 19.0641 10.2692C19.8768 11.0819 20.3333 12.1841 20.3333 13.3334C20.3333 14.4826 19.8768 15.5848 19.0641 16.3975C18.2515 17.2102 17.1493 17.6667 16 17.6667Z"
                    fill="#F8F9FA"
                  />
                </svg>
                {t("footer.dubai_office")}
              </h6>
              <div className="w-full h-[240px] rounded-2xl mb-8 max-w-[326px]">
                <iframe
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d28884.310132671646!2d55.25359281442909!3d25.185047260299033!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3e5f682def25f457%3A0x3dd4c4097970950e!2sBusiness%20Bay%20-%20Dubai%20-%20United%20Arab%20Emirates!5e0!3m2!1sen!2seg!4v1758309940387!5m2!1sen!2seg"
                  className="w-full h-full border-0 rounded-2xl"
                  allowFullScreen=""
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                ></iframe>
              </div>
              <div>
                <h6 className="text-base text-white font-semibold mb-2">
                  {t("footer.office_address")}
                </h6>
                <p className="font-normal text-sm text-white mb-8">
                  {(staticData
                    ? (staticData[`address_${i18n.language}`] || staticData.address || "") +
                      (staticData.building || "") +
                      (staticData.office || "")
                    : "") || t("footer.default_office_address")}
                </p>
              </div>

              <div className="bg-[#4E7770] rounded-[10px] px-4 py-2">
                <h4 className="footer-title flex items-center gap-2 text-white font-semibold text-xl mb-4">
                  <span>
                    <svg
                      width="28"
                      height="22"
                      viewBox="0 0 28 22"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M24.6667 5.66671L14 12.3334L3.33333 5.66671V3.00004L14 9.66671L24.6667 3.00004M24.6667 0.333374H3.33333C1.85333 0.333374 0.666664 1.52004 0.666664 3.00004V19C0.666664 19.7073 0.947616 20.3856 1.44771 20.8857C1.94781 21.3858 2.62609 21.6667 3.33333 21.6667H24.6667C25.3739 21.6667 26.0522 21.3858 26.5523 20.8857C27.0524 20.3856 27.3333 19.7073 27.3333 19V3.00004C27.3333 2.2928 27.0524 1.61452 26.5523 1.11442C26.0522 0.614325 25.3739 0.333374 24.6667 0.333374Z"
                        fill="#F8F9FA"
                      />
                    </svg>
                  </span>
                  {t("newsletter")}
                </h4>
                <p className="text-sx font-semibold text-white mb-4">
                  {t("newsletter_subtitle")}
                </p>
                <div>
                  <div className="join max-w-sm">
                    <input
                      className="input join-item bg-[#738E88] text-white placeholder:text-muted-light placeholder:font-semibold placeholder:text-xs"
                      placeholder={t("enter_email")}
                    />
                    <button className="btn btn-outline-white bg-white border-0 join-item">
                      <svg
                        width="21"
                        height="22"
                        viewBox="0 0 21 22"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M19.551 0.845966L19.657 0.839966L19.787 0.847966L19.877 0.863966L20 0.898966L20.107 0.944966L20.207 1.00197L20.297 1.06897L20.379 1.14397L20.431 1.20297L20.513 1.31897L20.565 1.41497C20.6117 1.51497 20.6417 1.6203 20.655 1.73097L20.66 1.83697C20.66 1.9123 20.652 1.98563 20.636 2.05697L20.601 2.17997L14.069 20.257C13.9452 20.5265 13.7466 20.7549 13.4968 20.915C13.2471 21.075 12.9566 21.1601 12.66 21.16C12.3929 21.1605 12.1302 21.092 11.8973 20.9612C11.6645 20.8303 11.4694 20.6414 11.331 20.413L11.266 20.286L7.914 13.584L1.244 10.248C0.997198 10.1351 0.784359 9.9594 0.626769 9.73846C0.469179 9.51751 0.37236 9.25907 0.345996 8.98897L0.339996 8.83997C0.339996 8.27997 0.640996 7.76797 1.181 7.46997L1.321 7.39997L19.338 0.893966L19.444 0.863966L19.551 0.845966Z"
                          fill="#0B7A3B"
                        />
                      </svg>
                    </button>
                  </div>
                </div>
              </div>
            </nav>
          </div>
        </footer>
        <footer className="footer  px-8 py-4">
          <div className="flex w-full items-center justify-between flex-wrap">
            <div>
              <h6 className="font-semibold text-white text-base mb-4">
                {t("follow_us")}
              </h6>
              <div className="flex gap-4 flex-wrap">
                {Array.isArray(socialMediaItems) &&
                  socialMediaItems.map((item, index) => (
                    <Link
                      key={index}
                      to={item.link}
                      aria-label={item.name + " Link"}
                      className="center_flex size-11 rounded-full bg-[#4E7770] hover:bg-success hover:text-white transition-colors"
                      target="_blank"
                    >
                      <span
                        className={`${item.iconClass} size-6 flex text-white`}
                      />
                    </Link>
                  ))}
              </div>
            </div>
              <aside className="grid-flow-col items-center">
              <p className="text-base font-semibold text-white">
                {staticData?.[`copyright_text_${i18n.language}`] ||
                  staticData?.copyright_text ||
                  t("footer_copyright")}
              </p>
              <p className="text-base font-semibold text-white text-end">
                {t("footer.made_with")} 
                <Link
                  className="link link-hover font-medium px-4 animate-bounce "
                  to="#"
                  aria-label="Love"
                  target="_blank"
                >
                  ❤️
                </Link>
                {" "}{t("footer.in_dubai")}
              </p>
            </aside>
          </div>
        </footer>
      </div>
    </>
  );
};

export default Footer;
